import { useEffect, useState } from 'react';
import Icon from '@common/assets';
import { RequestPageType } from '@components/acca/results/result/applyResult/v3Result';
import { useAccResultsTokenExample } from '@repository/acc';
import Colors from '@domain/constant/colors';
import { V2Route } from '@utils/routeUtil';
import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const SampleResult = () => {
  const { data } = useAccResultsTokenExample();
  const [height, setHeight] = useState(1040);
  const [src, setSrc] = useState('');
  const [requestPage, setRequestPage] = useState<RequestPageType>('check');
  const isOn = (page: RequestPageType) => page === requestPage;

  const resizeHeight = (event: MessageEvent) => {
    if (data?.url !== event.origin) return;
    const { height } = event.data;
    setHeight(height);
  };

  useEffect(() => {
    if (!data?.url || !data?.token) return;
    setSrc(V2Route.getAccaV3ResultPage(`${data?.url}`, `${data?.token}`, requestPage));
    window.addEventListener('message', resizeHeight);

    return () => window.removeEventListener('message', resizeHeight);
  }, [data, requestPage]);

  return (
    <div className={cx('resultArea')}>
      <div className={cx('resultWrap')}>
        <div className={cx('btnArea')}>
          <button
            className={cx('btn', 'apply', { on: isOn('check') })}
            onClick={() => setRequestPage('check')}
            type="button"
          >
            <Icon
              name="alertLight"
              width={32}
              height={32}
              fill={isOn('check') ? Colors.C_WHITE : Colors.C_COOL_GRAY_60}
            />
            응시 점검 결과
          </button>

          <button
            className={cx('btn', 'competency', { on: isOn('basic') })}
            onClick={() => setRequestPage('basic')}
            type="button"
          >
            <Icon
              name="contentsLight"
              width={32}
              height={32}
              fill={isOn('basic') ? Colors.C_WHITE : Colors.C_COOL_GRAY_60}
            />
            기본 분석 결과
          </button>
          <button
            className={cx('btn', 'deep', { on: isOn('deep') })}
            onClick={() => setRequestPage('deep')}
            type="button"
          >
            <Icon
              name="chartLight"
              width={32}
              height={32}
              fill={isOn('deep') ? Colors.C_WHITE : Colors.C_COOL_GRAY_60}
            />
            심층 분석 결과
          </button>
        </div>

        <iframe
          src={src}
          title="acc results"
          style={{ width: '1040px', height: height }}
          frameBorder="no"
          scrolling="no"
        />
      </div>
    </div>
  );
};

export default SampleResult;
